import { defineMessages } from 'react-intl';
import type { MessageTag, NoMessageValues } from 'react-intl';

export const taxHintMessages = defineMessages<{
  readonly carrierDeliveryDEFAULT: { readonly link: MessageTag };
  readonly carrierDeliveryL: { readonly link: MessageTag };
  readonly carrierDeliveryS: { readonly link: MessageTag };
  readonly titleDEFAULT: NoMessageValues;
  readonly titleL: NoMessageValues;
  readonly titleS: NoMessageValues;
  readonly dialogContent: NoMessageValues;
}>({
  carrierDeliveryDEFAULT: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Service & Versandkosten</link>',
    id: 'taxHint.text.carrierDelivery.default',
  },
  carrierDeliveryL: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Speditionsgebühr</link>',
    id: 'taxHint.text.carrierDelivery.l',
  },
  carrierDeliveryS: {
    defaultMessage: 'inkl. MwSt, zzgl. <link>Speditionsgebühr</link>',
    id: 'taxHint.text.carrierDelivery.s',
  },
  titleDEFAULT: {
    defaultMessage: 'Service & Versandkosten',
    id: 'taxHint.dialog.headline.default',
  },
  titleL: {
    defaultMessage: 'Speditionsgebühr',
    id: 'taxHint.dialog.headline.l',
  },
  titleS: {
    defaultMessage: 'Speditionsgebühr',
    id: 'taxHint.dialog.headline.s',
  },
  dialogContent: {
    defaultMessage:
      'Je Bestellung und Lieferanschrift zahlen Sie für Standardlieferungen 6 € Versandkosten (unabhängig vom Bestellwert).',
    id: 'taxHint.dialog.text',
  },
});
